if(document.location.href.indexOf("exp=none") == -1){

console.log("init Proteus Treatments -- 1.09");

// spotfix edit_box bug
observeSelector('.edit-box__button[disabled]', disabled_btn => {
  disabled_btn.removeAttribute("disabled");
});

// START trial box number input patch
observeSelector('.rich-text-select-wrapper', dropdown => {
    let options = dropdown.querySelectorAll('button.popover-listbox__option[data-id]');
    dropdown.querySelector('fieldset').classList.add("js-hidden");
    dropdown.querySelector('fieldset').insertAdjacentHTML("beforebegin", `
    <style>
    .js-trial-weight--input{
        padding: .5rem;
        border-radius: .625rem;
    }
    </style>
    <input aria-label="Enter Your pet's weight" type="number" class="js-trial-weight--input" placeholder="Your pet's weight"/> lbs
    `);
    document.querySelector('.js-trial-weight--input').addEventListener("keyup", () => {
      let pet_weight = document.querySelector('.js-trial-weight--input').value;
      let pet_type = "dog"
      
      if(window.location.href.indexOf("/collections/for-dogs") > -1){
        
        pet_type = "dog";
        if(pet_weight > 90){
            options[3].click()
        } else if(pet_weight > 50){
            options[2].click()
        } else if(pet_weight > 20){
            options[1].click()
        } else {
            options[0].click()
        }
        
      } else if(window.location.href.indexOf("/collections/for-cats") > -1){
        
        pet_type = "cat";
        if(pet_weight > 10){
            options[1].click()
        } else {
            options[0].click()
        }
        
      }

      let feeding_rec = calc_feeding_rec(pet_type, 5, 0, pet_weight, 0, "average")
      let feeding_rec_text = document.querySelectorAll('.select-button-info > p:first-child');
      
      for(let i = 0; i < feeding_rec_text.length; i++){
        feeding_rec_text[i].innerHTML = `
          <strong>Your Recommended Daily Feeding:</strong> ${feeding_rec} oz/day
        `;   
      }
      
    })
})
// END trial box number input patch

waitUntil(() => {
  return window.sessionStorage.getItem("VIVA-20") || window.location.href.indexOf("qa=VIVA-20") > -1 || window.location.href.indexOf("qa=viva-20") > -1
}).then(() => {

  window.sessionStorage.setItem("VIVA-20", "v1");
  console.log("[VIVA-20] v1 -- 0.01");

  let add_loading_animation = () => {
    waitForElement('.recharge-app .account-view .recharge-overview').then(shipments => {
      shipments.style.position = "relative";
      shipments.insertAdjacentHTML("afterbegin", `
        <div class="js-loading-animation" style="
          position: absolute;
          z-index: 999;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #fbf6e980;
        ">
          <style>
          .js-loading--ellipsis,
          .js-loading--ellipsis div {
            box-sizing: border-box;
          }
          .js-loading--ellipsis {
            display: inline-block;
            width: 80px;
            height: 80px;
            position: absolute;
            top: 25vh;
            left: 50%;
            transform: translate(-50%, -25%);
          }
          .js-loading--ellipsis div {
            position: absolute;
            top: 33.33333px;
            width: 13.33333px;
            height: 13.33333px;
            border-radius: 50%;
            background: currentColor;
            animation-timing-function: cubic-bezier(0, 1, 1, 0);
          }
          .js-loading--ellipsis div:nth-child(1) {
            left: 8px;
            animation: js-loading--ellipsis1 0.6s infinite;
          }
          .js-loading--ellipsis div:nth-child(2) {
            left: 8px;
            animation: js-loading--ellipsis2 0.6s infinite;
          }
          .js-loading--ellipsis div:nth-child(3) {
            left: 32px;
            animation: js-loading--ellipsis2 0.6s infinite;
          }
          .js-loading--ellipsis div:nth-child(4) {
            left: 56px;
            animation: js-loading--ellipsis3 0.6s infinite;
          }
          @keyframes js-loading--ellipsis1 {
            0% {
              transform: scale(0);
            }
            100% {
              transform: scale(1);
            }
          }
          @keyframes js-loading--ellipsis3 {
            0% {
              transform: scale(1);
            }
            100% {
              transform: scale(0);
            }
          }
          @keyframes js-loading--ellipsis2 {
            0% {
              transform: translate(0, 0);
            }
            100% {
              transform: translate(24px, 0);
            }
          }
          </style>
          <div class="js-loading--ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
      `);
    }).catch();
  };
  
  let select_next_months_week = (week_num) => {
    console.log("[VIVA-20] -- select_next_months_week()")
    document.querySelector('[role="button"].vc-arrow.is-right').click();
    setTimeout(() => {
      document.querySelector(`.weekday-position-7.week-${week_num}:not(.is-not-in-month) > span`).click();
      submit_update();
    }, 500);
  }
  
  let submit_update = () => {
    console.log("[VIVA-20] -- submit_update()")
    waitUntil(() => {
      return document.querySelectorAll('button.schedule-edit__button:not(.button--secondary)').length > 0 && 
        !document.querySelector('button.schedule-edit__button:not(.button--secondary)').disabled;
    }).then(() => {
      document.querySelector('button.schedule-edit__button:not(.button--secondary)').click();
    }).catch();
  }

  window.delay_shipment = () => {
    console.log("[VIVA-20] -- delay_shipment()")
    window.location.hash = '#/overview';
    waitUntil(() => {
      return document.querySelectorAll('button.schedule__reschedule-button').length > 0;
    }).then(() => {

      add_loading_animation();
      
      // wait for subscriptions to be returned
      setTimeout(() => {
        // open reschedule window
        document.querySelector('button.schedule__reschedule-button').click();
        document.querySelector('.js-loading-animation').remove();
      }, 5000);

      waitUntil(() => {
        return document.querySelectorAll('.weekday-position-7:not(.is-not-in-month)').length > 0;
      }).then(() => {

        // loop through week ends
        let week_ends = document.querySelectorAll('.weekday-position-7:not(.is-not-in-month)');
        for(let i = 0; i < week_ends.length; i++){
        
          if(week_ends[i].innerHTML.indexOf("vc-highlights") > -1){
        
            // is selected week
            let week_from_end_class = Array.from(week_ends[i].classList).find(className => className.startsWith('week-from-end-'));
            let week_from_end_val = week_from_end_class ? week_from_end_class.match(/\d+/)[0] : null;
        
            if(week_from_end_val == 1){
              select_next_months_week(3)
            } else if(week_from_end_val == 2){
              select_next_months_week(2)
            } else {
              
              document.querySelector(`.weekday-position-2.week-from-end-${parseInt(week_from_end_val) - 2}:not(.is-not-in-month) > span`).click(); 
              submit_update();
              
            }
            break;
          } else {
            if(i == week_ends.length - 1){
              // last loop
              // select_next_months_week(3)
            } 
          }
        }

      }).catch();
  
    }).catch();
      
  }

  observeSelector('.js-delay-order', discount_btn => {
    discount_btn.addEventListener("click", () => {
      // close drawer
      // document.querySelector('.cancellation__action.button--secondary').click();
      document.body.style = "";
      window.delay_shipment();
    });    
  });
  
  observeSelector('button.cancellation__action', btn => {

    waitUntil(() => {
      return window.selected_reason == "quantity" && btn.innerText.indexOf("Adjust My Box") > -1;
    }).then(() => {
      
      btn.style.display = "none";

      btn.insertAdjacentHTML("afterend", `
      <style>
      @media(max-width: 1000px){
        .js-delay-order{
          max-width: 100% !important;
        }
      }
      </style>
      <button class="js-delay-order align-c gap-12 button button--small" 
      style="width: 100%; max-width: 267px; margin: 0 auto;">
        <span>Delay Next Shipment</span>
      </button>`);

      let message_html = `
        <h4>We hear you.</h4>
        <p>We hear you! If you've got more than enough right now, let's push off the next shipment by two weeks.</p>
      `;
      document.querySelector('.wysiwyg--cancel-box').innerHTML = message_html
      setTimeout(() => { // in case conflicting w [VIVA-19]
        document.querySelector('.wysiwyg--cancel-box').innerHTML = message_html
      }, 100)
      
    }).catch();
    
  });
  
}).catch(); // END [VIVA-20]

window.sessionStorage.setItem("VIVA-19", "v1"); // implemented 100%
if((window.sessionStorage.getItem("VIVA-19") || window.location.href.indexOf("qa=VIVA-19") > -1) &&
  !window.localStorage.getItem("VIVA-19 offer claimed") && !window.sessionStorage.getItem("VIVA-20")){
  
  console.log("[VIVA-19] v1 -- 0.01");

  let apply_discount_code = (code) => {
    waitForElement('.your-box__billing-discount.your-box__block--card').then(discount_trigger => {
      discount_trigger.click();
      document.body.style = "";

      waitUntil(() => {
        return document.querySelectorAll('.discount-form__form input').length > 0;
      }).then(() => {

        let discount_input = document.querySelector('.discount-form__form input');
        discount_input.value = code;
        discount_input.dispatchEvent(new Event('input', {
          view: window,
          bubbles: true,
          cancelable: true
        }));

        waitUntil(() => {
          return !document.querySelector('.discount-form button:not(.button--secondary)').disabled;
        }).then(() => {
          document.querySelector('.discount-form button:not(.button--secondary)').click();
          window.localStorage.setItem("VIVA-19 offer claimed", true);
        }).catch();
        
      }).catch();

    }).catch();
  }

  observeSelector('.js-claim-discount', discount_btn => {
    console.log("[VIVA-19] v1 -- looking at discount_btn");
    
    discount_btn.addEventListener("click", () => {
      // close drawer
      document.querySelector('.cancellation__action.button--secondary').click();
      apply_discount_code("GET_10_OFF_");
      ga4_custom_metric("click: $10 discount");
    });    
  });
  
  observeSelector('button.cancellation__action', btn => {

    console.log("[VIVA-19] v1 -- looking at btn", btn.innerText);

    if(btn.innerText.indexOf("Cancel My Subscription") > -1){
      waitForElement('.js-claim-discount').then(discount_btn => {
        discount_btn.innerText = "Claim $10 Off";
      }).catch();
    }

    // window.selected_reason

    waitUntil(() => {
      return (window.selected_reason == "preference" || window.selected_reason == "digestiveIssue") && 
      btn.innerText.indexOf("I’ll Try This") > -1;
    }).then(() => {
      
      document.querySelector('.wysiwyg--cancel-box').insertAdjacentHTML("beforeend", `
        <p>If you’d like to test things out with one more order, we wanted to share a $10 credit on your next box for your patience.</p>
      `);
      
      btn.insertAdjacentHTML("afterend", `
      <button class="js-claim-discount align-c gap-12 button button--small" 
      style="width: 100%; max-width: 267px; margin: 0 auto;">
        <span>I'll Try This (Claim $10 Off)</span>
      </button>`);

      btn.style.display = "none";
      
    }).catch();

    waitUntil(() => {
      return (window.selected_reason == "budget" || window.selected_reason == "quantity") && 
      btn.innerText.indexOf("Adjust My Box") > -1;
    }).then(() => {

      if(window.selected_reason == "budget"){
        document.querySelector('.wysiwyg--cancel-box').innerHTML = `
          <h4>We hear you.</h4>
          <p>Feeding a 25% or 50% fresh diet still has its benefits and you can always modify your box to adjust the amount of food you’re receiving or update your delivery frequency. </p>
          <p>If you would like one more order to transition to feeding less Viva, we wanted to offer you a $10 credit on your next shipment!</p>
        `;
      } 

      if(window.selected_reason == "quantity"){
        document.querySelector('.wysiwyg--cancel-box').innerHTML = `
          <h4>We hear you.</h4>
          <p>You can always modify your box to adjust the amount of food you’re receiving or update your delivery frequency.</p>
          <p>To help with your concerns, we wanted to offer you a $10 credit on your next shipment!</p>
        `;
      }
      
      btn.innerHTML = "Adjust Box (Claim $10 Off)";
      window.apply_discount_after_update = true;

      waitUntil(() => {
        return document.querySelectorAll('button.edit-box__button:not(.button--secondary)').length > 0;
      }).then(() => {
        let update_btn = document.querySelector('button.edit-box__button:not(.button--secondary)');
        update_btn.innerText = "Update Box (and Claim $10 Off)";
        update_btn.addEventListener("click", () => {
          if(window.apply_discount_after_update){
            setTimeout(() => {
              apply_discount_code("GET_10_OFF_");
              window.apply_discount_after_update = false;
            }, 1500);
          }
        });
      }).catch();
      
    }).catch();

    waitUntil(() => {
      return (window.selected_reason == "packaging" || window.selected_reason == "other") && 
      btn.innerText.indexOf("Cancel My Subscription") > -1;
    }).then(() => {

      // default to [other]
      let message_html = `
        <h4>We are sorry to see you go.</h4> 
        <p>If you had a negative experience, we want to hear from you. We’re always looking to improve and your feedback goes a long way.</p>
        <p>If you’d like to give us another try, we wanted to share a $10 credit on your next box for any inconvenience.</p>
      `;
      if(window.selected_reason == "packaging"){
        message_html = `
          <h4>We are sorry to see you go.</h4> 
          <p>Please let us know below or <a href="mailto:info@vivarawpets.com">email</a> us about the packaging or quality issues you’ve been seeing. We’re always looking to improve and your feedback goes a long way. </p>
          <p>If you’d like to test things out with one more order, we wanted to share a $10 credit on your next box for the inconvenience.</p>
        `;
      }
      
      document.querySelector('.slideout__body h3').insertAdjacentHTML("afterend", `
        <style>
        .js-btn--secondary{
          background: #fff;
          color: #5b4d37;
          border: 1px solid #5b4d37;
        }
        
        @media(max-width: 1000px){
          .js-claim-discount{
            max-width: 100% !important;
          }
        }
        </style>
        
        <div class="wysiwyg wysiwyg--cancel-box">
          ${message_html}
        </div>
      `);
      document.querySelector('.slideout__body h3').style.display = "none";
      btn.classList.add("js-btn--secondary");

      btn.nextElementSibling.style.display = "none";

      btn.insertAdjacentHTML("afterend", `
      <button class="js-claim-discount align-c gap-12 button button--small" 
      style="width: 100%; max-width: 267px; margin: 0 auto;">
        <span>Claim $10 Off</span>
      </button>`);
      
    }).catch();  
    
  });
} // END [VIVA-19]


// mapping user interatcion GA4 metrics 

window.dataLayer = window.dataLayer || [];
const ga4_custom_metric = (name) => {
  console.log("ga4_custom_metric()", name);
  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': name,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });
};

if(window.location.href.indexOf("/tools/recurring/portal/") > -1){
  // active views in Vaulted Oak's reacharge app
  observeSelector('.recharge-app .account-view > .recharge-overview', () => {
    ga4_custom_metric("pageview: portal #overview");
  })

  observeSelector('.schedule__reschedule-button', btn => {
    btn.addEventListener("click", () => {
      ga4_custom_metric("click: reschedule #overview")
    });
  });

  observeSelector('.schedule-edit__button', btn => {
    btn.addEventListener("click", () => {
      if(btn.innerText.indexOf("Reschedule") > -1){
        ga4_custom_metric("click: confirm reschedule #overview")
      } else if(btn.innerText.indexOf("Nevermind") > -1){
        ga4_custom_metric("click: nevermind reschedule #overview")
      }
    });
  });

  observeSelector('.pet.recharge-schedule__item', btn => {
    btn.addEventListener("click", () => {
      ga4_custom_metric("click: pet-info #overview");
    });
  });

  observeSelector('.recharge-pet__add-button', btn => {
    btn.addEventListener("click", () => {
      ga4_custom_metric("click: add-pet #overview");
    });
  });
  
  observeSelector('.recharge-app .account-view > .your-box', () => {
    ga4_custom_metric("pageview: portal #your-box");
  })

  observeSelector('.recharge-app .account-view > .your-box button', btn => {
    console.log("observe button", btn.innerText);
    btn.addEventListener("click", (e) => {
      if(btn.innerText.indexOf("Edit Box") > -1){
        ga4_custom_metric("click: edit-box #your-box");
      }
    });
  });

  // TO-DO: drawer x clicks
  observeSelector('#cancel-box button.slideout__close', btn => {
    btn.addEventListener("click", () => {
      ga4_custom_metric("click: nevermind-cancel #your-box");
    });
  });

  window.selected_reason = "N/A";
  observeSelector('input[name="reason"]', cancellation_reason => {
    cancellation_reason.addEventListener("change", () => {
      window.selected_reason = document.querySelector('input[name="reason"]:checked').value;
    })
  })
  
  observeSelector('button.cancellation__action', btn => {
    btn.addEventListener("click", () => {
     if(btn.innerText.indexOf("Cancel My Subscription") > -1){
        ga4_custom_metric("click: confirm-cancel #your-box");
      } else if(btn.innerText.indexOf("Nevermind") > -1){
        ga4_custom_metric("click: nevermind-cancel #your-box");
      } else if(btn.innerText.indexOf("Next") > -1 || btn.innerText.indexOf("Continue to Cancel") > -1){
        ga4_custom_metric(`cancel reason: ${window.selected_reason}`);
      }
    });
  });

  observeSelector('.your-box__frequency', btn => {
    btn.addEventListener("click", () => {
      ga4_custom_metric("click: frequency #your-box");
    });
  });

  observeSelector('.your-box__billing-discount', btn => {
    btn.addEventListener("click", () => {
      ga4_custom_metric("click: discount #your-box");
    });
  });

  observeSelector('.your-box__cancel .your-box__block--card', btn => {
    btn.addEventListener("click", () => {
      ga4_custom_metric("click: cancellation #your-box");
    });
  });
  
  observeSelector('.recharge-app .account-view > .orders', () => {
    ga4_custom_metric("pageview: portal #order-history");
  })
  observeSelector('.recharge-app .account-view > .my-account', () => {
    ga4_custom_metric("pageview: portal #account");
  })
}

// observeSelector('.rich-text[class*="md:hidden"]', unnecessary_dupe => {
//   console.log('remove unnecessary_dupe')
//   unnecessary_dupe.remove();
// })

/* START TRIAL PACK URL */

// Function to get URL parameter
let get_param = (name, optSearch) => {
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(optSearch);
  return results === null ?
    '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

// Function to add items to cart and redirect to checkout
let atc_to_checkout = (products_data) => {

  ga4_custom_metric("trial pack ATC");
  // strip selling_plan and poperties
  products_data = products_data.map(item => {
    return {
        id: item.id,
        quantity: item.quantity
    };
  });
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: products_data
    })
  }).then(response => response.json()).then(data => {
    console.log('Item added to cart:', data);
    waitForElement('a[aria-controls="cart-drawer"]').then(cart_trigger => {
      cart_trigger.click();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch();
    
  }).catch(error => console.error('Error adding item to cart:', error));
}

// Main logic to parse trial-box parameter and add items to cart
let atc_trial_box = (trial_box_data = []) => {

  waitUntil(() => {
    return !!window.selling_plans_by_var_id && JSON.stringify(selling_plans_by_var_id).length > 200;
  }).then(() => {
    
    let atc_data = [];

    console.log("param value", trial_box_data)
    if(trial_box_data.indexOf('"') == -1){
      // reformat
      console.log("reformatted value", trial_box_data)
    }
    
    for(let i = 0; i < trial_box_data.length; i++){
      console.log("trying", trial_box_data[i])
      let [var_id_str, quantity_str, future_quantity_str] = trial_box_data[i].split(":");
      let var_id = parseInt(var_id_str);
      let quantity = parseInt(quantity_str);
      let future_quantity = parseInt(future_quantity_str);

      let looked_up_selling_plan = window.selling_plans_by_var_id[var_id];

      atc_data.push({
        id: var_id,
        quantity: quantity,
        selling_plan: looked_up_selling_plan,
        properties: {
          __petcalc: 1,
          _trial_duration: 2,
          _future_quantity: future_quantity,
          _future_frequency: '4 Week(s)'
        }
      });
      if(i == trial_box_data.length - 1){
        // clear_cart().then(() => {
          atc_to_checkout(atc_data);
        // })
        console.log("ATC data:", atc_data);
      }
    }
  }).catch(error => console.error('Error in waitUntil:', error));
};

if(get_param("trial-box")){
  atc_trial_box(JSON.parse(get_param("trial-box")))
}


/* END TRIAL PACK URL */

/* START ONE TIME BOX PATCH */

if(get_param("one-time-box")){
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }
    return response.json(); // Ensure the response is processed
  }).then(() => {
  
    add_items_to_cart({ items: JSON.parse(window.sessionStorage.getItem("otp_box_contents")) });
    window.sessionStorage.removeItem("otp_box_contents")
    window.sessionStorage.removeItem("default otp_box_contents")
    
  }).catch();
}

if(window.location.href.indexOf("/tools/recurring/") > -1 || window.location.href.indexOf("/account") > -1){

  observeSelector('button:not(.js-buy-ot-box)', portal_btn => {
    if(portal_btn.innerText.indexOf("One-Time Box") > -1){
      // unique selector in case multiple on the page
      let random_num = Math.floor(Math.random() * 1000000) + 1;

      // hide button for OTP only accts
      if(window.location.href.indexOf("/account") == -1){
        portal_btn.insertAdjacentHTML("afterend", `<button class="button button--small button--secondary button--transparent js-buy-ot-box" style="min-width: 266px; margin-top: .5rem; padding: 12px 20px;" data-otp-box="${random_num}">Buy a One-Time Box</button>`);
      }
      
      portal_btn.classList.add("js-hidden");
      waitForElement(`button[data-otp-box="${random_num}"]`).then(otp_box => {

        otp_box.addEventListener("click", (e) => {
          window.location.hash = '#/your-box';

          setTimeout(() => {
            if(document.querySelectorAll('.subscription-box__list .rc-product-card').length == 0){
              window.sessionStorage.setItem("default otp_box_contents", true);
              window.sessionStorage.setItem("otp_box_contents", JSON.stringify([
                {
                  id: window.var_id_lookup["Beef for Dogs - Ground"],
                  quantity: 1
                },
                {
                  id: window.var_id_lookup["Chicken for Dogs - Ground"],
                  quantity: 1
                },
                {
                  id: window.var_id_lookup["Turkey for Dogs - Ground"],
                  quantity: 1
                },
                {
                  id: window.var_id_lookup["Duck for Dogs - Ground"],
                  quantity: 1
                },{
                  id: window.var_id_lookup["Rabbit for Dogs - Ground"],
                  quantity: 1
                }
              ]));
            }
            
          }, 2000)
          

          waitUntil(() => {
            return !!window.sessionStorage.getItem("otp_box_contents") || document.querySelectorAll('.subscription-box__list .rc-product-card').length > 0;
          }).then(() => {
          
            let otp_box_contents = [];
            let box_contents = document.querySelectorAll('.subscription-box__list .rc-product-card');
            if(box_contents.length == 0){
              box_contents = document.querySelectorAll('.your-box__box .rc-product-card');
            }
            for(let i = 0; i < box_contents.length; i++){
              
              let prod_variant = box_contents[i].querySelector('[class*="rc-product-card__badge--"]').innerText;
              let prod_title = box_contents[i].querySelector('.rc-product-card__content h4').innerText;
              let prod_qty = parseInt(box_contents[i].querySelector('.rc-product-card__content .rc-product-card__weight').innerText.replace("x", "").replace(" lbs", "")) / 2;
              
              otp_box_contents.push({
                id: window.var_id_lookup[`${prod_title} - ${prod_variant}`],
                quantity: prod_qty
              })
  
              if(i == box_contents.length - 1){
  
                window.sessionStorage.setItem("otp_box_contents", JSON.stringify(otp_box_contents));
                
              }
            }

            console.log("otp_box_contents", JSON.parse(window.sessionStorage.getItem("otp_box_contents")));
            window.open('/?one-time-box=true', '_blank'); 
  
          }).catch()

        });

      }).catch();
    }
  })

}
/* END ONE TIME BOX PATCH */

/*

// START support for Order Protection
const options = {
  method: 'GET', 
  headers: {
    'Authorization': 'Bearer 7ebc4a39fe36743f08187e67b15fa9906ef993b375b86669'
  }
};

fetch('https://api.production.orderprotection.com/v1/split-tests', options)
.then(response => response.json())
.then(response => {
  console.log("proteus op response #1", response);

  // [VIVA-16] test should be the last one created, but if not... specify the id from a previous lookup
  let test_id = "cm2dnrpoq0092ma8l14b7eo30"; // default original test ID
  for (let i = 0; i < response.data.edges.length; i++) {
    if (response.data.edges[i].node.name.toLowerCase().indexOf("viva") > -1) {
      test_id = response.data.edges[i].node.id;
      break;
    }
  }

  fetch(`https://api.production.orderprotection.com/v1/split-tests/${test_id}/events`, options)
  .then(response_2 => response_2.json())
  .then(response_2 => {
    console.log("proteus op response #2", response_2);

    let variant_name = response_2.data.edges[response_2.data.edges.length - 1].node.metadata.settingsType;
    let variant_type = response_2.data.edges[response_2.data.edges.length - 1].node.type;

    console.log(`init [VIVA-16] // R5 Data -- 0.04`, response, response_2);
  }).catch(err => console.error(err));
}).catch(err => console.error(err));


async function get_op_session_info() {
  try {
    const response = await fetch(
      `https://api.production.orderprotection.com/v1/quote/insurance?store_url=viva-raw.myshopify.com`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch store settings');
    }

    const store_settings = await response.json();

    console.log("store_settings", store_settings)

    // Check if splitTestSettings exists before accessing token
    const sessionId = store_settings.splitTestSettings?.token || 'undefined session_id';
    const variantName = store_settings.splitTestSettings?.type || 'undefined variant_name';
    return {
      "variant_name": variantName,
      "session_id": sessionId,
    }

  } catch (error) {
    console.error('Error fetching store settings:', error);
    return 'Error retrieving session information';
  }
}

// Example usage of fetching and logging the session token
get_op_session_info().then((data) => {
  console.log(`[VIVA-16] R5 // Variant Name: ${data.variant_name} -- Session ID: ${data.session_id}`);
  window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'proteus_experiment_pageview',
      'proteus_exp_id': "VIVA-16-R5",
      'proteus_var_id': data.variant_name,
      'proteus_exp_name': "Package Protection Test",
      'proteus_exp_version': "0.01",
    });
});

// END support for Order Protection
*/

} // if(!exp=none)